import { CSSProperties } from 'react';
import { COLORS } from '../../../../globalStyles';

export const styles: Record<string, CSSProperties> = {
  list: {
    marginTop: '3rem',
  },
  answer: {
    fontSize: '1rem',
    lineHeight: 1.75,
    color: COLORS.muted,
    maxWidth: '44rem',
  },
};
